import { render, staticRenderFns } from "./ListTutorial.vue?vue&type=template&id=2f51a41a&"
import script from "./ListTutorial.vue?vue&type=script&lang=js&"
export * from "./ListTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports